import React from "react";
import FarmerImg from "../../../images/gbrCBN/CBNImg3.webp";
import UpdatesBanner from "../../UpdatesBanner/UpdatesBanner";
import AdvisorImg from "../../../images/AnimalVet1.jpg";
import HomeSubSection from "../HomeSubSection/HomeSubSection";
import HeaderComponent from "../Header/HeaderComponent";
import FooterComponent from "../Footer/FooterComponent";
import CBN from "../../../images/GBR Care (CBN Main Network) - GBR Care Main - 04-06-2024 N.gif";
import { Col, Container, Row } from "react-bootstrap";
import ProductionManagerImg from "../../../images/gbrPN/PNImg5.webp";
import CBNMainServices from "./CBNMainServices";
import CBNNetworkBenefits from "./CBNNetworkBenefit";
// Exporting the CBNNetwork functional component
export default function CBNNetwork() {
  return (
    <>
      {/* Header section */}
      <HeaderComponent />

      {/* Banner section for CBN Network */}
      <UpdatesBanner
        className="cbnbg text-white"
        bannerTitle="Seed to Sale"
        bannerbodycopy1={[
          <span key="1">
            GBR Care can BUILD, MANAGE & OPERATE its own customised CBN network
          </span>,
          <br key="2" className="d-md-block d-none" />,  
          <span key="3">
            to help farmers with everything they need from seed to sale
          </span>,
        ]}
        demo="true"
        bannerbodycopy="Local Trade | Quality Inputs | Insurance | Advisory | Capital"
      />

      {/* Section describing Managed Community Based Network */}
      <div className="subSectionWrapper">
        <h4 className="container-title text-center mx-md-4 ">
          Managed Community Based Network
        </h4>
        <Container>
          <Row className="justify-content-center">
            <Col md={6} sm={12}>
              {/* Infographic image for CBN */}
              <img
                className="w-100 h-100 cursor-initial"
                src={CBN}
                alt="Infographics"
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Services of CBN Network */}
      <CBNMainServices />

      {/* Benefits of CBN Network */}
      <CBNNetworkBenefits />

      {/* CBN Beneficiaries Section */}
      <div className="subSectionWrapper">
        <h2 className="text-center container-title">CBN BENEFICIARIES</h2>

        {/* Beneficiary: Collectives */}
        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="image16"
          description="Collectives encompass a diverse range of entities such as agricultural cooperatives, farmer producer organizations (FPOs), agribusiness companies, and local farmer markets. These groups function as intermediaries, buying from and selling to farmers, providing crucial market access, collective purchasing power, and support services.
            "
          description1="FPCs | NGOs | SHG | CS"
          descriptionTitle="Collectives"
          src={AdvisorImg}
          href2="auth/3/signup"
          buttoncont2="Register"
          onClick={() => {
            localStorage.setItem("userType", "Collective");
          }}
        />

        {/* Beneficiary: Farmers */}
        <HomeSubSection
          className="rowReverseAbout--mod borderedCards borderedCards--mod"
          className3="image18"
          description="Farmers are individuals or groups engaged in agricultural activities, including cultivating crops, raising livestock, or producing other agricultural commodities. They play a crucial role in food production, contributing to the supply of fruits, vegetables, grains, meats, and other essential products. Farmers often work on their own land or may lease or rent land for cultivation. Their activities involve planting, tending, and harvesting crops, as well as caring for animals and managing farm operations. 
            "
          descriptionTitle="
            Farmer"
          src={FarmerImg}
          href2="auth/3/signup"
          buttoncont2="Register"
          onClick={() => {
            localStorage.setItem("userType", "Farmer");
          }}
        />

        {/* Beneficiary: Agri Retailers */}
        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="agri-retailer-role"
          description="Agri-retailers are businesses that specialize in selling agricultural inputs such as seeds, fertilizers, pesticides, and farm equipment to farmers. They often provide a wide range of products and services tailored to the needs of the agricultural community, including agronomic advice, soil testing, and crop protection solutions. Agri-retailers play a crucial role in the agricultural supply chain, facilitating the distribution of essential inputs to farmers and supporting their efforts to maximize yields and profitability.
              "
          descriptionTitle="
              Agri Retailer"
          src={ProductionManagerImg}
          href2="auth/3/signup"
          buttoncont2="Register"
          onClick={() => {
            localStorage.setItem("userType", "Agri-Retailer");
          }}
          description1="Farm Machinery Retailers | Nutrition Retailers | Agri Input Retailers"
        />

        {/* Beneficiary: AgriMiner */}
        <HomeSubSection
          className="rowReverseAbout--mod borderedCards borderedCards--mod"
          className3="image18"
          description="GBR Care enables individual consultant to earn extra earnings anytime, from anywhere by just uploading farm and processing outlet details through the app. Once these details gets authenticated and approved by GBR Care representative, you will get your commission in your application digital wallet and you can transfer from your digital wallet to bank account.




            "
          descriptionTitle="
            Agriminer"
          src={FarmerImg}
          href2="auth/3/signup"
          buttoncont2="Register"
          onClick={() => {
            localStorage.setItem("userType", "AgriMiner");
          }}
        />
      </div>

      {/* Footer Section */}
      <FooterComponent />
    </>
  );
}

